import { render, staticRenderFns } from "./Tab1Component.vue?vue&type=template&id=71b614ac&scoped=true&"
import script from "./Tab1Component.vue?vue&type=script&lang=js&"
export * from "./Tab1Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b614ac",
  null
  
)

export default component.exports